import { PRIMARY_DOMAIN } from './types';

export interface ScannedCode {
  code: string;
  domain: string;
}

const SECONDARY_DOMAINS = ['m15.cl', 'm5d.cl'];
const CODE_RE = /^[A-Z0-9]{1,12}$/;

/**
 * Interpreta lo leído por la cámara o escrito a mano: `HTTPS://Q-R.CL/K7MX`, `q-r.cl/k7mx`, `m15.cl/K7MX` o `K7MX`.
 * Hosts de ambiente (dev.q-r.cl, *.web.app) cuentan como el dominio principal. Devuelve null si no es un QR de QuadRoam.
 */
export function parseScannedValue(raw: string): ScannedCode | null {
  const value = raw.trim();
  if (!value) return null;
  const bare = value.toUpperCase();
  if (CODE_RE.test(bare)) return { code: bare, domain: PRIMARY_DOMAIN };

  let url: URL;
  try {
    url = new URL(/^https?:\/\//i.test(value) ? value : `https://${value}`);
  } catch {
    return null;
  }
  const host = url.hostname.toLowerCase();
  const segments = url.pathname.split('/').filter(Boolean);
  if (segments.length !== 1) return null;
  const code = segments[0].toUpperCase();
  if (!CODE_RE.test(code)) return null;
  if (SECONDARY_DOMAINS.includes(host)) return { code, domain: host };
  if (host === PRIMARY_DOMAIN || host.endsWith(`.${PRIMARY_DOMAIN}`) || /^qr-shortener-[a-z]+-links\.web\.app$/.test(host)) {
    return { code, domain: PRIMARY_DOMAIN };
  }
  return null;
}
